// Events
import {
  COLLECTION_FILTER_RESET,
  COLLECTION_GRID_APPEND,
  COLLECTION_GRID_LOADING,
  COLLECTION_GRID_PREPEND,
  COLLECTION_GRID_RENDER,
  COLLECTION_GRID_UPDATE,
  MOUNT_COMPONENTS,
} from 'events';
// Lib
import Tracking from 'lib/tracking';
import { component } from 'picoapp';

import choozy from 'utils/choozy';
// Utils
import { bundle, clear, stringToNode } from 'utils/node';
import { placeholderItem } from 'utils/product-item';

export default component(async (node, ctx) => {
  const placement = node.dataset.placement ?? 'plp';
  const { grid, gridPromotionsWrapper, productPlaceholder, productItem } = choozy(node);
  const { banner: gridPromotions } = choozy(gridPromotionsWrapper, true);

  // For the previous button
  ctx.on(COLLECTION_GRID_PREPEND, (state, products) => {
    grid.prepend(bundle(products));
    ctx.emit(MOUNT_COMPONENTS);
    // Trigger group price refresh after new nodes are mounted
    document.dispatchEvent(new CustomEvent('group-price:mount'));

    Tracking.trackViewItemList({
      products: []
        .concat(products || [])
        .map((item) => JSON.parse(item.dataset.productItem || '{}')),
      placement,
    });
  });

  ctx.on(COLLECTION_GRID_LOADING, () => {
    clear(grid);
    grid.innerHTML = Array(6)
      .fill('')
      .map((v, i) => placeholderItem(i))
      .join('');
  });

  ctx.on(COLLECTION_GRID_APPEND, (state, products) => {
    grid.appendChild(bundle(products));
    ctx.emit(MOUNT_COMPONENTS);
    // Trigger group price refresh after new nodes are mounted
    document.dispatchEvent(new CustomEvent('group-price:mount'));

    Tracking.trackViewItemList({
      products: []
        .concat(products || [])
        .map((item) => JSON.parse(item.dataset.productItem || '{}')),
      placement,
    });
  });

  ctx.on(COLLECTION_GRID_RENDER, (state, products) => {
    clear(grid);
    grid.appendChild(bundle(products));

    if (
      gridPromotions &&
      (!state.activeFilters.length ||
        state.activeFilters.every(([filterName]) => filterName === 'sort_by'))
    )
      grid.append(bundle(gridPromotions));

    ctx.emit(MOUNT_COMPONENTS);
    // Trigger group price refresh after new nodes are mounted
    document.dispatchEvent(new CustomEvent('group-price:mount'));

    Tracking.trackViewItemList({
      products: []
        .concat(products || [])
        .map((item) => JSON.parse(item.dataset.productItem || '{}')),
      placement,
    });
  });

  ctx.on(COLLECTION_GRID_UPDATE, ({ pagination, cachedProducts = [], cachedPagination = null }) => {
    if (pagination.items !== undefined) {
      if (pagination.items === 0) {
        const emptyPageReset = node.querySelector('[data-filter-reset]');
        if (emptyPageReset) {
          emptyPageReset.addEventListener('click', () => {
            ctx.emit(COLLECTION_FILTER_RESET);
          });
        }
      }
    }

    if (cachedPagination === null && grid.classList.contains('show-placeholders')) {
      grid.classList.remove('show-placeholders');
      productPlaceholder.forEach((placeholder) => {
        grid.removeChild(placeholder);
      });
    }

    if (cachedProducts && cachedProducts.length > 0) {
      const [products] = stringToNode(cachedProducts, [
        '[data-product-item-container],[data-banner]',
      ]);
      products.forEach((product) => {
        if (product.hasAttribute('data-product-item'))
          product.setAttribute('data-component', 'product-item');
      });
      clear(grid);
      grid.appendChild(bundle(products));
      ctx.emit(MOUNT_COMPONENTS, {
        cachedProducts: [],
        pagination: { ...pagination, previousPage: '' },
      });
    }
  });

  Tracking.trackViewItemList({
    products: []
      .concat(productItem || [])
      .map((item) => JSON.parse(item.dataset.productItem || '{}')),
    placement,
  });
});
